export default __webpack_public_path__ + "static/media/AI_research.804f7dc4.png";